import { LockOutlined } from "@ant-design/icons";
import { useLogin } from "@refinedev/core";
import { Alert, Button, Card, Form, Input, Typography } from "antd";
import { useState } from "react";

export const LoginPage = () => {
  const { mutate: login, isPending } = useLogin<{ password: string }>();
  const [error, setError] = useState<string | null>(null);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <Card style={{ width: 380 }}>
        <Typography.Title level={4} style={{ textAlign: "center", marginBottom: 24 }}>
          Instagram Comment Bot
        </Typography.Title>

        {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} showIcon />}

        <Form
          layout="vertical"
          onFinish={({ password }: { password: string }) => {
            setError(null);
            login(
              { password },
              { onError: (e) => setError(e?.message ?? "Не удалось войти") },
            );
          }}
        >
          <Form.Item
            name="password"
            label="Пароль администратора"
            rules={[{ required: true, message: "Введите пароль" }]}
          >
            <Input.Password prefix={<LockOutlined />} size="large" autoFocus />
          </Form.Item>

          <Button type="primary" htmlType="submit" size="large" block loading={isPending}>
            Войти
          </Button>
        </Form>
      </Card>
    </div>
  );
};
